import {
  GENERATE_IMPERSONATE_TOKEN,
  generateImpersonateTokenFailed,
  generateImpersonateTokenSucceeded,
  resetRequestStatus,
} from '@va/dashboard/actions/api';
import { setInstanceId } from '@va/dashboard/actions/app';
import moment from 'moment';
import { all, call, delay, put, takeLatest } from 'redux-saga/effects';
import Api from 'wix/apiClient';
import { appHistory } from '@va/shared/router';

export function* watchers() {
  yield all([takeLatest(GENERATE_IMPERSONATE_TOKEN, generateImpersonate)]);
}

export function* generateImpersonate(action) {
  try {
    const requestData = {
      email: action.data.username.trim(),
      password: action.data.password,
      impersonate: action.data.instanceId,
    };

    const response = yield call(Api.generateImpersonate, {}, requestData);
    const now = moment().unix();
    const credentials = {
      token: response.token,
      refreshToken: response.refreshToken,
      impersonateToken: true,
      //auth token is valid for an hour
      tokenExpiry: now + 3600,
      //refresh token is valid for 24 hours
      refreshTokenExpiry: now + 86400,
      instanceId: response.impersonate,
    };

    yield put(generateImpersonateTokenSucceeded(credentials));
    yield put(setInstanceId(response.id));

    appHistory.push('/impersonate', { impersonateData: credentials });
  } catch (error) {
    yield put(generateImpersonateTokenFailed(error));
    yield delay(4000);
    yield put(resetRequestStatus('generateImpersonateToken'));
  }
}
